<template>
  <div class="header">
    <a
      class="cs-store-link"
      :href="siteUrl"
    >
      <div class="cs-logo">
        <img src="@/assets/icons/cs-icon.png">
        <div class="cs-domain-name">
          {{ domainName }}
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Header',
  computed: {
    ...mapState('cart', ['cart']),

    domainName() {
      return this.cart.siteUrl
    },

    siteUrl() {
      return `https://${this.domainName}`
    }
  }
}

</script>

<style lang="scss" scoped>
.header {
  background-color: #34485e;
  display: flex;
  padding: 8px 0 8px 5%;

  .cs-store-link {
    text-decoration: none;

    .cs-logo {
      align-items: center;
      display: flex;
      flex-grow: 9;

      img {
        width: 47px;
        height: 47px;
      }

      .cs-domain-name {
        color: #fff;
        display: flex;
        flex-direction: column;
        font-family: 'Open Sans Light', 'Open Sans';
        font-size: 24px;
        font-weight: 300;
        margin-left: 5px;
        text-align: left;
      }
    }
  }

  .cs-header-cart {
    color: #fff;
    cursor: pointer;
    display: flex;
    flex-grow: 1;
    padding-top: 15px;

    img {
      height: 28px;
      width: 32px;
    }

    p {
      font-size: 12px;
      margin-left: 10px;
    }
  }
}
</style>
